import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonType } from "components/Button/Button";
import ShareModal from "components/ShareModal/ShareModal";
import { useModal } from "components/Modal/context/ModalContext";
import { ModalButtons } from "components/Modal/ModalButtons";
import "./CourseDetails.scss";

const CourseDetails = ({ course, linkage = false }) => {
	const { openModal } = useModal();

	const getViewFullCourseLink = (course, isShareLink = false) => {
		let result = `/course-view#courseId-${course.Id}`;
		if (!isShareLink && course.SubContent.length > 1) {
			result += `-moduleId-${course.SubContent[0].Id}`;
		}
		return result;
	};

	const handleOpenShareModal = ({ shareLink, contentName }) => {
		openModal("Share", <ShareModal shareLink={shareLink} contentName={contentName} />, ModalButtons.None);
	};

	const getContinueSection = () => {
		course.hasContent = course.SubContent.some((value) => value.ContentType.length);
		if (course.hasContent) {
			return (
				<div className="list-view-item-continue">
					<Button
						text={course.LastViewed.Continuing ? "Continue" : "Start"}
						to={`/player#courseId-${course.Id}-moduleId-${course.LastViewed.ContentId}-submoduleId-${course.LastViewed.SubContentId}`}
						glint={!course.LastViewed.Continuing}
					/>
					<p>
						<strong>{course.LastViewed.Continuing ? "Last Viewed" : "Get Started"}:</strong>{" "}
						{course.LastViewed.SubContentName}
					</p>
				</div>
			);
		}
		return null;
	};

	const content = (
		<div className="list-view-item-details">
			<div className="list-view-item-details-text">
				{linkage ? (
					<Link to={getViewFullCourseLink(course)}>
						<h2>{course.Name}</h2>
					</Link>
				) : (
					<h2>{course.Name}</h2>
				)}
				<p className="list-view-item-details-text-description">{course.Description}</p>
				{getContinueSection()}
			</div>
			<div className="list-view-item-details-image">
				<div className={`list-view-item-details-links ${linkage ? "" : "share-only"}`}>
					<Button
						type={ButtonType.Tertiary}
						text="Share"
						icon={faShareNodes}
						onClick={() =>
							handleOpenShareModal({ shareLink: getViewFullCourseLink(course, true) , contentName : course.Name })
						}
					/>
					{linkage && (
						<Button
							to={getViewFullCourseLink(course)}
							type={ButtonType.Tertiary}
							text="View Full Course"
							scroll={true}
						/>
					)}
				</div>
				{linkage ? (
					<Link to={getViewFullCourseLink(course)}>
						<img alt={course.Name} src={course.ImageUri} />
					</Link>
				) : (
					<img alt={course.Name} src={course.ImageUri} />
				)}
			</div>
		</div>
	);

	return <>{content}</>;
};

export default CourseDetails;
